import React, { Component } from 'react';

//styles
import './App.scss';

import Footer from '../Footer/Footer';
import Header from '../Header/Header';
import TopSection from '../TopSection/TopSection';
import MiddleSection from '../MiddleSection/MiddleSection';
import BottomSection from '../BottomSection/BottomSection';
import Article from '../Article/Article';
import '../../static/fonts/opensanshebrew/stylesheet.css'
import { HashRouter as Router, Route } from 'react-router-dom'
import { GA_Event } from '../Analytics/Analytics'
import { isMobile } from '../../static/helper'

class App extends Component {
  adsPush() {
    var _adsManager = new window.AdsManager();
    if (isMobile()) {
      _adsManager.defineSlots([_adsManager.transitionSlot]);
    }
    if (isMobile()) {
      window.googletag.cmd.push(() => { window.googletag.display("gpt-transition"); });
    }
  }

  componentDidMount() {
    this.adsPush();
  }

  render() {
    return (
      <div className="App" id="App">

        <Router basename="/">
          <div>
            <Route exact path="/" render={() =>
              <div>
                <Header isArticle={false} sendGA={GA_Event} />
                <TopSection />
                <MiddleSection />
                <BottomSection />
              </div>
            } />
            <Route path="/article/:article/:comment?" component={(router) => <Article router={router} />} />
          </div>
        </Router>
        <Footer />
        <div id="gpt-transition"></div>
      </div>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/Components/App/App.js